
import _ from 'lodash'

export default function(module) {
  module.controller('KeywordManagmentController', ['keywordService', '$scope', '$q', function (keywordService, $scope, $q) {

    let vm = this
    vm.paging = {
      limit: 50,
      perPage: 50,
      total: 0,
      currentPage: 1
    }
    vm.query = ""
    vm.isLoading = false

    keywordService.listVerticals().then(results => {
      vm.verticals = results.verticals;
    })

    vm.dirty = []

    vm.loadPage = function () {
      vm.isLoading = true
      const offset = (vm.paging.currentPage - 1) * vm.paging.perPage
      keywordService.listKeywords(vm.query, offset, vm.paging.limit, undefined, false).then(results => {
        vm.paging.total = results.total
        vm.keywords = results.keywords.map(kw => {
          kw.vertical = _.find(vm.verticals, { "_id": kw.verticalId }) || null
          return kw
        })
        vm.isLoading = false
      })
    }

    vm.search = function() {
      vm.paging.currentPage = 1
      vm.loadPage()
    }

    vm.selectVertical = function(verticalIndex, keywordIndex) {
      vm.keywords[keywordIndex].vertical = _.get(vm.verticals, verticalIndex)
      vm.dirty.push(vm.keywords[keywordIndex])
      vm.save()
    }

    vm.save = function() {
      if (vm.dirty.length === 0) {
        return;
      }

      vm.saving = true
      let promises = _.uniqBy(vm.dirty, "_id").map(kw => {
        let temp = _.clone(kw)
        temp.verticalId = _.get(kw, 'vertical._id')
        delete temp.vertical

        return keywordService.saveKeyword(temp)
      })

      $q.all(promises).then(done => {
        vm.saving = false
      })
      vm.dirty = []
    }

    $scope.$watch('vm.paging.currentPage', (before, after) => {
      if (before !== after) {
        vm.loadPage()
      }
    })

    vm.loadPage()
  }])
}
